import React, { useState, useMemo } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Avatar,
  Typography,
  Button,
  IconButton,
  Stack,
  useTheme,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { printHtml } from "../utils/htmlToPrint";

// const sampleStudents = [
//   {
//     id: "S001",
//     name: "Aman Kumar",
//     father: "Ramesh Kumar",
//     standard: "8",
//     dob: "2011-06-12",
//     photo: photo,
//     mobile: '8055942603',
//     address: 'new mhalagi nagar, near nagoba mandeer, nagpur-440034 MH',
//     logo: logo,
//     school_name: "Sant's Paul Convent High School",
//     school_address: 'behind radda krishna mandir, Hudkeshwar Road, Nagpur - 440034 MH',
//   },
//   {
//     id: "S002",
//     name: "Neha Sharma",
//     father: "Suresh Sharma",
//     standard: "9",
//     dob: "2010-02-22",
//     photo: photo,
//     mobile: '8055942603',
//     address: 'new mhalagi nagar, near nagoba mandeer, nagpur-440034 MH',
//     logo: logo,
//     school_name: 'Living hope English Medium School',
//     school_address: 'Sundara bhatha, Disst. Sarangarh - 440034 C.G.',
//   },
//   {
//     id: "S003",
//     name: "Ravi Patel",
//     father: "Mahesh Patel",
//     standard: "7",
//     dob: "2012-10-05",
//     photo: photo,
//     mobile: '8055942603',
//     address: 'new mhalagi nagar, near nagoba mandeer, nagpur-440034 MH',
//     logo: logo,
//     school_name: 'Mother Teresa Convent High School',
//     school_address: 'behind radda krishna mandir, Hudkeshwar Road, Nagpur - 440034 MH',
//   },
// ];

const quickPalettes = [
  "#1e1e2f",
  "#0b6623",
  "#8a2be2",
  "#c68642",
  "#2b547e",
  "#b71c1c",
  "#004d40",
  "#0066cc",
];

export default function StudentIDCards() {
  const theme = useTheme();
  const location = useLocation();
  const { students } = location.state || [];

  const initialColors = useMemo(() => {
    const map = {};
    students.forEach((s, i) => {
      map[s.id] = quickPalettes[i % quickPalettes.length];
    });
    return map;
  }, [students]);

  const [colors, setColors] = useState(initialColors);
  const [globalColor, setGlobalColor] = useState("");
  // const [bottom, setBottom] = useState(initialColors);
  // const [top, setTop] = useState(initialColors);
  const [fontcolor, setFontcolor] = useState("white");
  // const [height, setHeight] = useState(205);
  const [layout, setLayout] = useState(true);
  // const [hide, setHide] = useState("");

  const applyGlobalColor = () => {
    if (!globalColor) return;
    const next = { ...colors };
    students.forEach((s) => (next[s.id] = globalColor));
    setColors(next);
  };

  const navigate = useNavigate();

  const handleBack = () => navigate(-1); // go back one page
  // const applyFontColor = (studentId, color) => {
  //   setFontcolor((prev) => ({ ...prev, [studentId]: color }));
  // };

  // const handleBotomColor = (studentId, color) => {
  //   setBottom((prev) => ({ ...prev, [studentId]: color }));
  // };

  // const handleTopColor = (studentId, color) => {
  //   setTop((prev) => ({ ...prev, [studentId]: color }));
  // };

  const handleLayout = () => {
    setLayout(!layout);
  };

  const onPrint = () => {
    printHtml("student-id-cards-root");
     window.location.reload();
    // setHide("none");
    // sessionStorage.setItem("hide", true);
    // setTimeout(() => {
    //   window.focus();
    //   window.print();
    //   setHide("block");
    //   sessionStorage.setItem("hide", false);
    // }, 500);
  };

  return (
    <Box sx={{ py: 1 }}>
      {/* Controls */}
      <Card sx={{ mb: 2, p: 2,}}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
          <Stack direction="row" spacing={1} alignItems="center">
            <ColorLensIcon sx={{ fontSize: 30 }} />
            {/* <Typography variant="subtitle1">Colour:</Typography> */}
            <Stack direction="row" spacing={1}>
              {quickPalettes.map((c) => (
                <IconButton
                  key={c}
                  onClick={() => {
                    setGlobalColor(c);
                    const next = { ...colors };
                    students.forEach((s) => (next[s.id] = c));
                    setColors(next);
                  }}
                  sx={{ bgcolor: c, width: 20, height: 20, border: "1px solid rgba(0,0,0,0.15)" }}
                />
              ))}
            </Stack>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="subtitle1">Global Color:</Typography>
            <input
              type="color"
              value={globalColor || "#000000"}
              onChange={(e) => setGlobalColor(e.target.value)}
              style={{ width: 42, height: 32, border: "none", background: "transparent" }}
            />
            <Button variant="contained" size="small" color="warning" onClick={applyGlobalColor}>
              Apply
            </Button>
            <Button variant="contained" size="small" color="warning" onClick={handleLayout}>
              Layout
            </Button>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="subtitle1">Font Color:</Typography>
            <input
              type="color"
              value={fontcolor || "#fff"}
              onChange={(e) => setFontcolor(e.target.value)}
              style={{ width: 42, height: 32, border: "none", background: "transparent" }}
            />
          </Stack>

          <Box sx={{ flex: 1 }} />
          <Button variant="outlined" sx={{ bgcolor: '#3f2d01', color: '#fff' }} startIcon={<ArrowBackIcon />} onClick={handleBack}>
            Back
          </Button>

          <Button variant="outlined" sx={{ bgcolor: 'orange', color: '#fff' }} startIcon={<PrintIcon />} onClick={onPrint}>
            Print / Save as PDF
          </Button>
        </Stack>
      </Card>

      {/* Cards Grid */}
      {layout ? (
        <Box id="student-id-cards-root">
          <Grid container spacing={2}>
            {students?.map((stu) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={stu.id}>
                <Card
                  elevation={3}
                  sx={{
                    height: 206,
                    width: 328,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    borderRadius: 2,
                    overflow: "hidden",
                    boxShadow: "0 3px 12px rgba(0,0,0,0.2)",
                  }}
                >

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      // bgcolor: "#fff",
                      bgcolor: colors[stu.id] || theme.palette.primary.main,
                      borderBottom: "1px solid #ddd",
                      p: 0.4,
                      gap: 1.5,
                    }}
                  >
                    <Avatar
                      src={stu.logo}
                      alt="School Logo"
                      sx={{ width: 60, height: 60, borderRadius: 1 }}
                    />
                    <Box sx={{ color: fontcolor }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                        {stu.school_name}
                      </Typography>
                      <Typography variant="caption" sx={{ display: "block", lineHeight: 1.2 }}>
                        {stu.school_address} | Tel: {stu.school_phone}
                      </Typography>
                      {/* <Typography variant="caption">Tel: {stu.school_phone}</Typography> */}
                    </Box>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        // height: 72,
                        width: "100%",
                        display: "flex",
                        alignItems: "flex-start",
                        p: 0.5,
                        gap: 0.8,
                      }}
                    >
                      <Box sx={{ display: "flex", flexDirection: 'column', alignItems: "center" }}>
                        <Avatar
                          src={stu.photo || undefined}
                          sx={{ width: 80, height: 80, borderRadius: 1 }}
                        >
                          {(!stu.photo && stu.name) ? stu.name.split(" ").map(n => n[0]).slice(0, 2).join("") : ""}
                        </Avatar>
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>
                          {"Principal"}
                        </Typography>
                      </Box>
                      <Box sx={{
                        display: 'grid',
                        color: "#1f0066ff",
                        rowGap: 0,
                      }}>

                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{stu.name}</Typography>
                        <Typography variant="caption" lineHeight={1.3}><strong>Class:</strong> {stu.standard} | {stu.section} || <strong>  DoB: </strong>
                          {new Date(stu.dob).toLocaleDateString()}</Typography>

                        <Typography variant="caption" lineHeight={1.3}><strong>Father:</strong> {stu.father}</Typography>

                        {/* <Typography variant="caption"><strong> DoB: </strong>
                          {new Date(stu.dob).toLocaleDateString()}
                        </Typography> */}
                        <Typography variant="caption" lineHeight={1.3}><strong>Mobile:</strong> {stu.mobile}</Typography>

                        <Typography variant="caption" lineHeight={1.1}>
                          <strong>Add.:</strong> {stu.address}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      backgroundColor: colors[stu.id] || theme.palette.primary.main,
                      padding: "6px 10px",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="caption" sx={{ fontWeight: "bold", color: fontcolor }}>
                      IDENTITY CARD
                    </Typography>
                    <Typography variant="caption" sx={{ fontWeight: "bold", color: fontcolor }}>
                      Academic Session: {stu.academicYear}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : (
        <Box id="student-id-cards-root">
          <Grid container spacing={0}>
            {students?.map((student) => (
              <div style={{ display: "flex", justifyContent: "center", margin: "10px" }}>
                <Card
                  sx={{
                    width: 205,
                    height: 328,
                    border: "3px solid " + `${colors[student.id] || theme.palette.primary.main}`,
                    borderRadius: "10px",
                    boxShadow: 5,
                    background: "linear-gradient(135deg, #e3f2fd, #ffffff)",
                    position: "relative",
                    display: "flex",          // make card flex
                    flexDirection: "column",  // vertical layout
                  }}
                >
                  <div
                    style={{
                      background: colors[student.id] || theme.palette.primary.main,
                      color: fontcolor,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    <Avatar
                      src={student.logo}
                      alt="School Logo"
                      sx={{ width: 50, height: 50, borderRadius: 1 }}
                    />
                    <Typography variant="subtitle2" fontWeight="bold" lineHeight={1.1}>
                      {student.school_name}
                    </Typography>
                  </div>

                  <div
                    style={{
                      background: colors[student.id] || theme.palette.primary.main,
                      color: fontcolor,
                      textAlign: "center",
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-around",
                      alignItems: "center",
                      paddingTop: 3,
                    }}
                  >
                    <Typography variant="caption" lineHeight={1.1}>
                      {student.school_address} | Tel: {student.school_phone}
                    </Typography>
                  </div>

                  <CardContent sx={{ textAlign: "center", py: 0.5, flexGrow: 1 }}>
                    <Avatar
                      src={student.photo}
                      alt={student.name}
                      sx={{
                        width: 80,
                        height: 80,
                        margin: "0px auto",
                        border: "2px solid" + `${colors[student.id] || theme.palette.primary.main}`,
                      }}
                    />
                    <Typography variant="subtitle2" color="blue" fontWeight="bold">
                      {student.name}
                    </Typography>

                    <Box
                      sx={{
                        color: "black",
                        display: "grid",
                        // flexWrap: "wrap",
                        justifyContent: "center",
                        justifyItems: "start",
                        rowGap: 0,
                      }}
                    >
                      <Typography variant="caption" lineHeight={1.1}><strong>Father:</strong> {student.father}</Typography>
                      <Typography variant="caption" lineHeight={1.3}><strong>Class:</strong> {student.standard} | {student.section} </Typography>
                      <Typography variant="caption" lineHeight={1.3}><strong>DoB: </strong>{student.dob}</Typography>
                      <Typography variant="caption" lineHeight={1.3}><strong>Mobile:</strong> {student.mobile}</Typography>
                      <Typography variant="caption" lineHeight={1.1}>
                        <strong>Add: </strong> {student.address}
                      </Typography>
                    </Box>
                  </CardContent>

                  {/* Fixed Footer */}
                  <div
                    style={{
                      background: colors[student.id] || theme.palette.primary.main,
                      color: fontcolor,
                      textAlign: "center",
                      padding: "5px",
                      borderBottomLeftRadius: "5px",
                      borderBottomRightRadius: "5px",
                    }}
                  >
                    <Typography variant="caption" fontWeight="bold">
                      Academic Session:  {student.academicYear}
                    </Typography>
                  </div>
                </Card>

              </div>
            ))}
          </Grid >
        </Box >
      )}
    </Box >
  );
}